export const locale = {
    lang: 'es',
    data: {
        'NAV': {
            'DASHBOARD': 'Dashboard',
            'APPLICATIONS': 'Aplicaciones',
            'USER': 'Usuarios',
            'JOB': 'Cargo',
            'INFRA': 'Infraestructura',
            'SETTING': 'Configuraciones',
            'MODULE': {
                'TALKING': 'Talking',
                'USAGE': 'Usage',
                'INVENTORY': 'Inventory',
                'VOICEBIOMETRIC': 'Voice Biometric',
                'GEO': 'Geolocation',
                'REALTIME' : 'Realtime',
                'VOICE_BIOMETRIC': 'Voice Biometric'
            },
            'PROFILE': 'Perfil'
        },        
        'REALTIME': {
            'REALTIME': 'Tiempo Real',
            'PRESENCE': 'Presencia',
            'LIVE': 'En directo',
            'ONLINE': 'En línea',
            'OFFLINE': 'Fuera de Línea',
            'INCALL': 'En Llamada',
            'INMUTE': 'Mute',
            'HEADSETS': 'Auriculares',
            'HEADSET': 'Auricular'
        },
        'TALKING': {
            'TALKING': 'Hablando',
            'HOME': 'Inicio',
            'SUMMARY': 'Resumen',
            'TEAM_MEMBERS': 'Miembros',
            'TARGET': 'Objetivo',
            'CALLS': 'Llamadas',
            'TOTAL_CALL_USER': 'TOTAL DE LLAMADAS POR OPERADOR',
            'TOTAL_CALL_TIME': 'TIEMPO TOTAL DE LLAMADAS',
            'TOTAL_SPEAK_TIME': 'TIEMPO TOTAL DE CONVERSACIÓN',
            'TOTAL_MUTE_TIME': 'TEMPO TOTAL MUDO',
            'TOTAL_CALLS': 'TOTAL DE LLAMADAS',
            'LIVE': 'En Directo',
            'NAME': 'Nombre',
            'USER': 'Usuario',
            'SHORT': 'Corto',
            'LONG': 'Largo',
            'SHORT_SING': 'Corta',
            'LONG_SING': 'Larga',
            'TMA': 'TMA' ,
            'TMF': 'TMC',
            'TMM': 'TMM',
            'TTA': 'TTA',
            'TA': 'TA',
            'TF': 'TC',
            'TM': 'TM',
            'CALL_DETAIL': 'Detalle de Llamada',
            'PERIOD': 'Periodo',
            'MAP': 'Mapa'
        },
        'USAGE' : {
            'USAGE' : 'Uso',
            'USAGE_TIME' : 'Tiempo de Uso',
            'CALL_TIME' : 'Tiempo de Llamada',
            'MUTE_TIME' : 'Tiempo Mudo',
            'DISCONNECTIONS' : 'Desconexiones',
            'MODELS': 'MODELOS',
            'HEADSET_USED': 'AURICULAR EN USO',
            'DISCONNECTIONS_UPPER': 'DESCONEXIONES SUPERIORES',
            'TOTAL_USER': 'TOTAL DE USO POR USUARIO',
            'TOTAL_USAGE': 'TOTAL DE USO',
            'TOTAL_SPEAK': 'TOTAL DE CONVERSACIÓN',
            'TOTAL_MUTE': 'HORAS MUDO',
            'ON' : 'Activo',
            'CALL': 'Llamada',
            'MUTE' : 'Mudo',
            'PAS': 'Posición de Atendimiento', 
            'COMPUTER': 'Computador',
            'TOTAL_MODEL': 'USO TOTAL POR MODELO',
            'TOTAL_USAGE_CALL': 'USO TOTAL DE LLAMADAS / USO / MUDO',
            'CONTROL_TIME': 'Tiempo de Control',
            'HEADSET_TIME': 'Tiempo de Auricular',
            'TOTAL_COMPUTER': 'Total de Computadores'

        },
        'INVENTORY' : {
            'INVENTORY' : 'Inventario',
            'HEADSETS' : 'Auriculares',
            'ACTIVE' : 'Activo',
            'INACTIVE' : 'Inactivo',
            'OUT_OF_SERVICE' : 'Fuera de servicio',
            'CONNECTED' : 'Conectado',
            'DISCONNECTED' : 'Desconectado',
            'DISCONNECTIONS' : 'Desconexiones',
            'MODELS': 'MODELOS',
            'HEADSET_USED': 'AURICULAR UTILIZADO',
            'TOTAL_USAGE': 'TIEMPO DE USO',
            'DISCONNECTIONS_UPPER': 'DESCONEXIONES SUPERIORES',
            'PRODUCT_NAME': 'Nombre de Producto',
            'SERIAL': 'Serial',
            'HEADSET_STATUS': 'Estado del Auricular',
            'HEADSET_FIRST_CONN': 'Primer Acceso',
            'HEADSET_LAST_CONN': 'Ultimo Acesso',
            'USER_NAME': 'Nombre de Usuario',
            'COMPUTER_NAME': 'Nombre de Computador',
            'INFRA_NAME': 'Nombre de INFRAESTRUCTURA',
            'HEADSET_MODEL': 'MODELO DE AURICULAR',
            'HEADSET_ACTIVE': 'ACTIVO / INACTIVO / SIN USO',
            'MANUFACTURER': 'Fabricante',
            'QTD': 'Cantidad',
            'USAGE': 'Uso'
        },
        'BUTTONS': {
            'DELETE': 'EXCLUIR',
            'SAVE': 'Guardar',
            'ADD': 'ADICIONAR'
        },
        'SETTINGS': {
            'SETTINGS': 'Configuraciones',
            'INVENTORY': 'Inventário',
            'USAGE': 'Uso',
            'BEEP_MUTE_ALLERT': 'Beep de Alerta de Mudo',
            'MODULES': 'Módulos',
            'NAME': 'Nombre',
            'EDIT': 'Editar',
            'NEW': 'Nuevo',
            'SOFTPHONE': 'Softphone',
            'SOUNDS': 'Sonidos',
            'BEEP_VOLUME': 'Beep de Volumen',
            'BEEP_MUTE_ON': 'Beep de Mudo Activado',
            'BEEP_MUTE_OFF': 'Beep de Mudo Apagado',
            'AUDIO' : 'Audio',
            'GAIN_MIN': 'Volumen Minimo',
            'GAIN_MAX': 'Volumen Máximo',
            'MUTE': 'Mudo',
            'MUTE_ON': 'Mudo Activado',
            'MUTE_CONTROL': 'Control de Mudo',
            'MAX_MUTE_TIME': 'Tiempo Máximo de Mudo',
            'MUTE_ALLERT': 'Alerta de Mudo',
            'CALLS': 'Llamadas',
            'TMA_TARGET': 'Meta de TMA',
            'TMM_TARGET': 'Meta de TMM',
            'SHORT_CALL': 'Llamada Corta',
            'LONG_CALL': 'Llamada Larga',
            'INVENTORY_DAYS_ACTIVE': 'Inventario de Dia Activo',
            'INVENTORY_DAYS_INACTIVE': 'Inventario de Dia Inactivo',
            'TALKING': 'Hablando',
            'STUDIO': 'Estudio',
            'VOICE': 'Voz',
            'GENERAL': 'General',
            'PRESENCE_TIME': 'Tiempo de Presencia',
            'GEO_TIME': 'Tiempo de Geolocalización',
            'NOISEOFF': 'Ruido apagado',
            'OUT_NOISE': 'Ruido Afuera',
            'OUT_AUDIO': 'Audio Afuera',
            'OUT_BLOCK': 'Bloquear',
            'DISCONNECTIONS': 'Desconexiones',
            'VOICE_VOICE_CONFIDENCE': 'Confiabilidad de Voz',
            'VOICE_TEXT_CONFIDENCE': 'Confiabilidad de Voz de Texto',
            'OUT_EFFECT': 'Efecto Afuera'
        },
        'INFRA': {
            'INFRA': 'Infraestructura',
            'NAME': 'Nombre',
            'EDIT': 'Editar',
            'NEW': 'Nuevo',
            'NETWORK': 'Red',
            'HOMEOFFICE': 'Home Office',
            'IN LOCO': 'En el Local',
            'PAS': 'Posición de Atendimiento'
        },
        'COMPUTER': {
            'EDIT': 'EDITAR',
            'NAME': 'NOMBRE',
            'POSITION': 'Posición',
            'HOMEOFFICE': 'Home Office', 
            'SO': 'Sistema Operacional', 
            'IP': 'IP', 
            'MAC ADDRESS': 'Dirección de Computador',
            'VERSION': 'Versión',
            'LICENCE': 'Licencia',
            'DTH_LICENCE': 'Data de Expiración'
        },
        'USER': {
            'USER': 'Usuario'
        },
        'AGENT': {
            'NAME': 'Nombre',
            'USER NAME': 'Nombre de Usuario',
            'DOMAIN': 'Dominio'
        },
        'GEO': {
            'MAP': 'Mapa',
            'ADDRESS': 'Dirección',
            'GEOLOCATION' : 'Geolocalización',
            'NOT LOCATION' : 'Sin Localización'
        },
        'PROFILE': {
            'PROFILE': 'Perfil',
            'LOCATION': 'Localización'
        },
        'VOICE_BIOMETRIC': {
            'VOICE_BIOMETRIC' : 'Biometria de Voz',
            'FINISHED': 'Finalizado',
            'SUCCESS': 'Verificación con Exito',
            'USERS': 'Usuarios',
            'FAILS': 'Fallas'
        }
    }
};
